import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Common } from '../../utils/common';

const $ = window.$;

function EmployeePerformanceTable({ tableData, isAutomotiveIndustry }) {
  const tableEl = useRef(null);

  useEffect(() => {
    const $el = $(tableEl.current);
    const table = $el.DataTable({
      columns: columnBuilder(isAutomotiveIndustry),
      data: tableData,
      keys: true,
      dom: 't',
      lengthMenu: [
        [10, 25, 50, 100, -1],
        [10, 25, 50, 100, 'All'],
      ],
      stateSave: true,
      stateSaveCallback: function (_oSettings, oData) {
        if (!Common.in_crm_mode()) {
          localStorage.setItem('DataTables-AI-EveryLeadDash', JSON.stringify(oData));
        }
      },
      stateLoadCallback: function () {
        if (!Common.in_crm_mode()) {
          return JSON.parse(localStorage.getItem('DataTables-AI-EveryLeadDash'));
        }
      },
      buttons: [
        {
          extend: 'colvis',
          text: 'Select Columns',
          titleAttr: 'Select Columns',
          collectionLayout: 'three-column',
          columns: ':gt(0)',
        },
        {
          extend: 'excelHtml5',
          text: 'Data Export',
          title: 'Top_8_Employee_Performance',
          titleAttr: 'Export as Excel',
          exportOptions: {
            columns: (i) => {
              const hideFromExport = [];
              const isVisible = table.column(i).visible();
              const isNotForExport = hideFromExport.includes(i);
              return isVisible && !isNotForExport ? true : false;
            },
          },
        },
      ],
      columnDefs: [{ className: 'table_cell_centered_text', targets: '_all' }],
      paging: true,
      responsive: true,
      destroy: true,
    });

    return () => {
      // Destroys DataTable instance whenever component unmounts
      table.destroy();
    };
  }, [tableData, isAutomotiveIndustry]);

  return (
    <div style={{ padding: '20px 0px' }}>
      <div className='text-center'>
        <h3>
          <span className='fa fa-users'></span> Top 8 - Employee Appointment Performance
        </h3>
      </div>
      <div className='table-responsive'>
        <table
          ref={tableEl}
          className='table table-hover table-striped vertical_centered table-bordered'
          style={{ width: '100%' }}
        />
      </div>
    </div>
  );
}

function columnBuilder(isAutomotiveIndustry) {
  const columns = [];
  columns.push({ title: 'Employee Name', data: 'employeename' });
  columns.push({
    title: isAutomotiveIndustry ? 'Appointment Conversion %' : 'Conversion %',
    data: 'percent',
    render: (data) => `
      <div class="progress">
        <div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar"  aria-valuemin="0" aria-valuemax="100" style="width: ${data}%;">
          <span class="sr-only">${data}% Complete</span>
        </div>
        <span class="progress-completed">${data}%</span>
      </div>
    `,
  });
  columns.push({ title: 'Total Calls', data: 'total', render: $.fn.dataTable.render.number(',') });
  if (isAutomotiveIndustry) {
    columns.push({
      title: 'Appointments Offered %',
      data: 'offered_percent',
      render: (data) => `
        <div class="progress">
          <div class="progress-bar progress-bar-offered progress-bar-striped active" role="progressbar"  aria-valuemin="0" aria-valuemax="100" style="width: ${data}%;">
            <span class="sr-only">${Number(data)}% Complete</span>
          </div>
          <span class="progress-completed">${Number(data)}%</span>
        </div>
      `,
    });
  }
  columns.push({
    title: isAutomotiveIndustry ? 'Appointments Made' : 'Booked Calls',
    data: 'appts',
    render: $.fn.dataTable.render.number(','),
  });
  columns.push({
    title: isAutomotiveIndustry ? 'Alerts' : 'Missed Opps',
    data: 'alerts',
    render: $.fn.dataTable.render.number(','),
  });
  return columns;
}

EmployeePerformanceTable.propTypes = {
  tableData: PropTypes.array.isRequired,
  isAutomotiveIndustry: PropTypes.bool.isRequired,
};

export default EmployeePerformanceTable;
